module.exports = __webpack_public_path__ + "img/重要时期保障_m.f8c3d320.png";